"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web3_eth_contract_1 = require("web3-eth-contract");
exports.Contract = web3_eth_contract_1.Contract;
//# sourceMappingURL=types.js.map